<template>
  <span v-if="!status.explanation" class="tag-level-desing live-wait-tag" :class="status.tone">{{ status.label }}</span>
  <el-tooltip
    v-else
    :value="isOpen"
    :content="status.explanation"
    placement="top"
    effect="dark"
    manual
    :popper-class="popperClass"
  >
    <button
      type="button"
      class="tag-level-desing live-wait-tag"
      :class="status.tone"
      :aria-label="`${status.label}. ${status.explanation}`"
      :aria-expanded="String(isOpen)"
      @pointerenter="openForMouse"
      @pointerleave="closeForMouse"
      @click="togglePinned"
      @keydown.esc="unpin"
    >
      {{ status.label }}<i class="live-wait-tag__info">i</i>
    </button>
  </el-tooltip>
</template>

<script>
import { Tooltip } from 'element-ui'

const MOUSE_POINTER = 'mouse'
const POPPER_CLASS = 'live-wait-status-popper'

export default {
  name: 'LiveWaitStatusTag',
  components: {
    [Tooltip.name]: Tooltip
  },
  props: {
    status: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isHovered: false,
      isPinned: false
    }
  },
  computed: {
    isOpen () {
      return this.isHovered || this.isPinned
    },
    popperClass () {
      return POPPER_CLASS
    }
  },
  mounted () {
    document.addEventListener('click', this.unpinOnOutsideClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.unpinOnOutsideClick)
  },
  methods: {
    openForMouse (event) {
      this.isHovered = event.pointerType === MOUSE_POINTER
    },
    closeForMouse () {
      this.isHovered = false
    },
    togglePinned () {
      this.isPinned = !this.isPinned
    },
    unpin () {
      this.isPinned = false
    },
    unpinOnOutsideClick (event) {
      if (!this.$el.contains(event.target)) {
        this.unpin()
      }
    }
  }
}
</script>

<style scoped>
.live-wait-tag {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  border: 0;
  border-radius: 8px;
  padding: 3px 12px;
  font-family: inherit;
  font-weight: 800;
}
.live-wait-tag.green {
  color: #1f5e3a;
}
.live-wait-tag.orange {
  color: #8a3b00;
}
.live-wait-tag.red {
  color: #7a1f1f;
}
.live-wait-tag.info {
  color: #0a5c6e;
  background: #dbf8fd;
}
.live-wait-tag.indigo {
  color: #4a0b94;
  background: #eee6f7;
}
.live-wait-tag__info {
  display: inline-grid;
  place-items: center;
  width: 15px;
  height: 15px;
  margin-left: 6px;
  border: 1.5px solid currentColor;
  border-radius: 50%;
  font-style: normal;
  font-size: 11px;
  line-height: 1;
}
</style>

<style>
.live-wait-status-popper {
  max-width: 280px;
  line-height: 1.4;
}
</style>
